import { render, staticRenderFns } from "./ProductizeUseCaseDigitalAudiencesPage.vue?vue&type=template&id=9370c3b0&scoped=true"
import script from "./ProductizeUseCaseDigitalAudiencesPage.vue?vue&type=script&lang=js"
export * from "./ProductizeUseCaseDigitalAudiencesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9370c3b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9370c3b0')) {
      api.createRecord('9370c3b0', component.options)
    } else {
      api.reload('9370c3b0', component.options)
    }
    module.hot.accept("./ProductizeUseCaseDigitalAudiencesPage.vue?vue&type=template&id=9370c3b0&scoped=true", function () {
      api.rerender('9370c3b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ProductizeUseCaseDigitalAudiencesPage.vue"
export default component.exports